/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import keys from 'lodash/fp/keys.js';
import { getFormMeta } from 'redux-form';
import { createSelector } from 'reselect';
import { CREATE_USER } from '#constants/users/form/createUser/name.js';
import createDeepEqualSelector from '#selectors/support/createDeepEqualSelector.js';
import getTouchedFromMeta from '#support/utility/form/getTouchedFromMeta/index.js';

const selectTouchedFields = createDeepEqualSelector(getFormMeta(CREATE_USER), getTouchedFromMeta);

export const selectHasTouchedFields = createSelector(
  selectTouchedFields,
  touched => keys(touched).length > 0
);
